module.exports = __webpack_public_path__ + "img/logo_suite_klaus.387ec062.svg";